
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    FORMAT_SD_CARD_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { formatSDCardResult } from 'Redux/actions';
import { clientPOST } from 'Core/data/RestApi';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';

function* formatSDCard({ payload }) {
    try {

        const { esn, id } = payload
        const headers = {
            'Content-Type': 'application/json'
        };

        let QUERY = `
                mutation updateVidFleetFormatSdCard ($unitId: Int!) {
                   result: updateVidFleetFormatSdCard (unitId: $unitId)
                }
          `;

        let result = yield call(
            clientMutation,
            QUERY,
            {
                unitId: id
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (result) {
            result = JSON.parse(result.result)
            yield put(formatSDCardResult({ result }))
        }

    } catch (exc) {
        let errorResponse = exc;
        if (exc.request && exc.request.response)
            errorResponse = JSON.parse(exc.request.response)

        yield put(formatSDCardResult({ error: errorResponse }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/formatSDCard/redux/saga",
            "formatSDCard",
        )
    }
}

function* watchMethods() {
    yield takeEvery(FORMAT_SD_CARD_REQUEST, formatSDCard);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}